export class SearchResult {
  type: string;
  description: string;
  icon: string;
  url: string;
  location: string;
  isGroup: boolean;
  showMore: boolean;
  sort: number;
  size: number;
  lastWriteDt: string;
  snippet: string;
  externalLink: boolean;

  constructor() { }
}

export class FileSearchResult {
  folderId: string;
  groupId: string;
  entryId: string;
  parentId: string;
  path: string;
  name: string;
  locked: boolean;
  size: number;
  type: string;
  snippet: string;
  snippetHtml: string;
  lastModified: string;
  uploadedBy: string;
  uploadedByUsername: string;
  numVersions: number;
  isFolder: boolean;

  constructor() { }
}

export type SearchSource = 'CUB' | 'Egnyte' | 'SharePoint';

// A single, source-agnostic result used by the unified enterprise search page.
export class UnifiedSearchResult {
  source: SearchSource;
  title: string;
  subtitle: string;
  snippet: string;
  url: string;
  externalLink: boolean;
  typeHint: string;
  // Pill/grouping key. For CUB/Egnyte this equals the source; for SharePoint it is the
  // specific location (e.g. "OneDrive", "PropertyFiles001") so each location gets its own pill.
  group: string;
  // For Lease Files (SharePoint PropertyFiles sites) results are sub-grouped by lease then folder,
  // parsed from the guaranteed path ".../Lease Documents/<lease>/<folder>/...".
  leaseName?: string;
  folderName?: string;

  constructor(init?: Partial<UnifiedSearchResult>) {
    Object.assign(this, init);
  }
}
